import { render } from "./ListEvGroup.vue?vue&type=template&id=79a58be0"
import script from "./ListEvGroup.vue?vue&type=script&lang=js"
export * from "./ListEvGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__